import { createSlice } from "@reduxjs/toolkit";
import { InitialStateConfigVariaveis } from "./models";

const initialState: InitialStateConfigVariaveis = {
  screenfilter: "",
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Variáveis",
        index: 0,
        active: true,
        name: "variaveis",
      },
      {
        title: "Tabelas",
        index: 1,
        active: true,
        name: "tabelas",
      },
    ],
  },
};

const configVariaveisSlice = createSlice({
  name: "variaveisApp/configVariaveis",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
    },
    clearFilter: (state) => {
      state.screenfilter = "";
    },
  },
});

export const { changeTab, clearFilter } = configVariaveisSlice.actions;

export default configVariaveisSlice.reducer;
